{
  "actions": "액션"
}
